import * as React from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { Button, ButtonVariant, ButtonTone, ButtonSize, ButtonShape } from '../../button'
import type { PartProps } from '../../../lib/part-props'

interface DialogCloseProps extends PartProps<React.ComponentProps<typeof BaseDialog.Close>> {
  className?: string
  variant?: ButtonVariant
  tone?: ButtonTone
  size?: ButtonSize
  shape?: ButtonShape
}

export function DialogClose({ className, render, children, variant, tone, size, shape, ...props }: DialogCloseProps) {
  if (render) {
    return <BaseDialog.Close render={render} {...props} />
  }

  return (
    <BaseDialog.Close
      render={
        <Button variant={variant} tone={tone} shape={shape} size={size} className={className}>
          {children}
        </Button>
      }
      {...props}
    />
  )
}
